import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  Model,
} from '@savgroup-front-common/types';

interface GetAsKeysByModelTypePayload {
  sellerId: string;
  dataSourceUrl: string;
  values: {
    [key: string]: string;
  };
  isFromStandard?: boolean;
}

async function getAsKeysByModelTypeQuery({
  sellerId,
  values,
  dataSourceUrl,
  isFromStandard,
}: GetAsKeysByModelTypePayload): Promise<
  BackResponse<Model[]> | BackResponseFailure
> {
  try {
    const url = buildUrl(
      `${APIConfiguration.base.slice(0, -1)}${dataSourceUrl}`,
      {
        sellerId,
        getFromStandard: isFromStandard?.toString(),
        ...values,
      },
    );

    const response = await apiCall<BackResponse<Model[]>>(url, {
      method: SUPPORTED_METHODS.GET,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default getAsKeysByModelTypeQuery;
